import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import ModalHeader from '@common-components/headers/ModalHeader';
import useAppSelector from '@hooks/useAppSelector';
import { environmentSelector } from '@selectors/commonSelectors';

const QHPIneligibleModal = props => {
    const {
        modalHeaderProps,
        actions: {
            hideModal
        }
    } = props;

    const { exchangeName } = useAppSelector(environmentSelector);

    const handleCloseModal = () => hideModal();

    return (
        <Fragment>
            <ModalHeader {...modalHeaderProps } />
            <div className="grid-container">
                <div className="gi-modal__body" id={`${modalHeaderProps.modalId}_body`}>
                    <p>
                        <FormattedMessage id="further_action.modal.QHP_ineligible_msg" values={{ exchangeName }}/>
                    </p>
                </div>
            </div>
            <div className="gi-modal__controls">
                <button className="usa-button usa-button--outline gi-button gi-button__outline" onClick={handleCloseModal}>
                    <FormattedMessage id="dashboard.ok"/>
                </button>
            </div>
        </Fragment>
    );
};

export default QHPIneligibleModal;
